<template>
    <div class="l-modal">
       <div class="loading-modal w-full px-4 md:px-0">
           <div class="loader bg-white w-full md:w-4/5 mx-auto rounded px-4 lg:px-8 lg:pb-6" v-on-clickaway="close">
             <div class="pt-6">
                 <div class="flex justify-between">
                     <div>
                     <p class="text-sm mt-4 cursor-pointer font-bold text-lg">
                         Policy info
                     </p>
                     </div>
                     <font-awesome-icon icon="times-circle" class="cursor-pointer text-red-500 text-base lg:text-xl" @click="$emit('close')" />
                 </div>
                 <div class="mt-8">
                
                 </div>
                 <p class="font-bold mt-6 underline">Gadget Details</p>
                 <ul class="mt-4 grid gap-4 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
                     <li>
                         <p>Gadget Name</p>

                         <p v-for="gadget in policy.metadata.Gadgets" :key="gadget.id" class="mt-2 lg:mt-4 font-bold mb-6">{{ gadget.name }} - {{ gadget.amount }}</p>
                     </li>
                    
                 </ul>
                     
                 <p class="font-bold underline">KYC Info</p>
                 <ul class="mt-4 grid gap-4 md:grid-cols-2 lg:grid-cols-4 lg:gap-8" >
                     <li>
                         <p>Name</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.enrollee.name}} </p>
                     </li>
                     <li>
                         <p>Email</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.enrollee.email}}</p>
                     </li>
                     <li>
                         <p>Telephone 1</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.Phone1}}</p>
                     </li>
                     <li>
                         <p>Telephone 2</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.Phone2}}</p>
                     </li>
                     <li>
                         <p>Address</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.user.address}}</p>
                     </li>
                     <li>
                         <p>Date Of Birth</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.DateOfBirth}}</p>
                     </li>
                     <li>
                         <p>Nationality</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.Nationality}}</p>
                     </li>
                     <li>
                         <p>Occupation</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.Occupation}}</p>
                     </li>
                     <li>
                         <p>Employer</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.Employer}}</p>
                     </li>
                     <li>
                         <p>Employer Address</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.EmployerAddress}}</p>
                     </li>
                     <li>
                         <p>ID Type</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.IdType}}</p>
                     </li>
 
                     <li>
                         <p>ID Number</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.IdNumber}}</p>
                     </li>
                     <li>
                         <p>ID Issue Date</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.IdIssueDate}}</p>
                     </li>
                     <li>
                         <p>ID Expiry Date</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.IdExpiryDate}}</p>
                     </li>
                     <li>
                         <p>Tax ID Number</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.TaxID}}</p>
                     </li>
                     <li>
                         <p>AccountName</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.AccountName}}</p>
                     </li>
                     <li>
                         <p>AccountNumber</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.AccountNumber}}</p>
                     </li>
                     <li>
                         <p>AccountType</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.AccountType}}</p>
                     </li>
                     <li>
                         <p>BankBranch</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.BankBranch}}</p>
                     </li>
                     <li>
                         <p>BankName</p>
                         <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.metadata.BankName}}</p>
                     </li>
 
 
                     
                 </ul>
                 <hr class="mt-6"> 
                 <a :href="policy.metadata.Signature" v-if="policy.metadata.Signature" target="_blank" rel="noopener noreferrer" class="mt-6 block text-green-500 underline">View Signature</a>
                 <p v-else class="mt-6">Signature link not available</p>
                 
             </div>
           </div>
       </div>
     </div>
 </template>
 
 <script>
 import { directive as onClickaway } from 'vue-clickaway';
 export default {
     props:['policy'],
     data(){
         return {
             existing: ''
         }
     },
     methods:{
         close(){
           this.$emit('close')
         // console.log('closeee')
         }
     },
     directives: {
         onClickaway: onClickaway,
     },
     mounted(){
         console.log(this.policy)
     }
 }
 </script>
 
 <style scoped>
 .loader{
   position: relative;
   top: 5px;
   max-width: 1000px
 }
 .img{
   width: 120px
 }
 
 </style>